import React from "react";
import { ContainerTable, TableView } from "../../../components/Table";
import { formatCurrency } from "../../../services/app";
import { useApp } from "../../../contexts";
import {
  CellRowValue,
  ContainerTableMobile,
  EqualIcon,
  TextCellTable,
} from "../styles";
import { CellRowImage } from "../../wallet-list/styles";
import { useNavigate } from "react-router-dom";
import { TYPE_WALLET_DETAIL } from "../../../constants";
import {
  DesktopContainer,
  MobileContainer,
} from "../../../components/Container";
import { WalletRowItem } from "./WalletRowItem";
import { RecordNotFound } from "../../../components/RecordNotFound";
import { getCoinCodeImage } from "../../../utils/helper";

export const TableCommon = ({ data, visible, tab }) => {
  const { T, formatLocalCurrency, getCurrency } = useApp();
  const navigate = useNavigate();

  const columns = [
    {
      title: T(
        tab === TYPE_WALLET_DETAIL.OPTION
          ? "Opportunity token"
          : tab === TYPE_WALLET_DETAIL.CRYPTO
          ? "Coin"
          : "Credit"
      ),
      dataIndex: "coin",
      key: "coin",
      width: 300,
      sorter: (a, b) => a.coin.toString().localeCompare(b.coin),
      render: (text, record, index) => {
        return (
          <CellRowImage style={{ minWidth: 60 }}>
            <img
              alt=""
              style={{ width: 28, height: 28 }}
              src={`/assets/images/otc/crypto/${getCoinCodeImage(
                text
              )?.toLowerCase()}.svg`}
            />
            <span style={{ marginLeft: 4 }}>{text}</span>
          </CellRowImage>
        );
      },
    },
    {
      title: T("Market Price"),
      dataIndex: "marketPrice",
      key: "btcValue",
      align: "right",
      className: "btc-value",
      width: 200,
      sorter: (a, b) => a.marketPrice - b.marketPrice,
      render: (text, record, index) => (
        <TextCellTable>
          {formatLocalCurrency(record.marketPrice)}
        </TextCellTable>
      ),
    },
    {
      title: T("Amount"),
      dataIndex: "amount",
      key: "amount",
      align: "right",
      width: 400,
      render: (text, record, index) => (
        <TextCellTable>{formatCurrency(record.amount, 8, getCurrency())}</TextCellTable>
      ),
    },
    {
      title: T("BTC Value"),
      dataIndex: "btc",
      key: "btc",
      className: "btc-value",
      align: "right",
      width: 300,
      render: (text, record, index) => {
        return !visible ? (
          "********"
        ) : (
          <CellRowValue>
            <>
              <div className="flex flex-col gap-1 items-end">
                <p className="font-normal text-[12px] lg:text-[16px] text-right">
                  {formatCurrency(text, null, getCurrency())}
                </p>
                <span
                  className="highlight"
                  style={{
                    gap: 8,
                    fontSize: 16,
                    justifyContent: "flex-end",
                  }}
                >
                  <EqualIcon />
                  {formatLocalCurrency(record.local)}
                </span>
              </div>
            </>
          </CellRowValue>
        );
      },
      sorter: (a, b) => parseFloat(a.btc) - parseFloat(b.btc),
    },
  ];

  const onDetail = (type, id, record) => {
    if (tab !== TYPE_WALLET_DETAIL.OPTION) {
      if (record.coin === "SGT" && record.type === 5) {
        navigate(
          `/wallet-detail/gameCurrencySGT?code=${record.coin}`
        );
      } else if (record.coin === "SZT" && record.type === 1) {
        navigate(
          `/wallet-detail/${TYPE_WALLET_DETAIL.GAMECURRENCY}?code=${record.coin}`
        );
      } else {
        navigate(`/wallet-detail/${type}?walletId=${id}&code=${record.coin}`);
      }
    } else {
      navigate(`/wallet-detail/option/?walletId=${id}&code=${record.coin}`);
    }
  };
  return (
    <div>
      <div className="mt-[10px] lg:mt-[20px]">
        <DesktopContainer>
          <ContainerTable>
            <TableView
              scroll={{ x: true }}
              tableLayout={"fixed"}
              pagination={false}
              dataSource={data}
              columns={columns}
              isClickRow
              onRow={(record, rowIndex) => {
                return {
                  onClick: (event) => {
                    onDetail(tab, record.id, record);
                  },
                };
              }}
            />
          </ContainerTable>
        </DesktopContainer>
        <MobileContainer>
          {data?.length ? (
            <ContainerTableMobile>
              {data?.map((item, index) => (
                <WalletRowItem
                  // SourceCoin={
                  //   TabWalletOption.GAMECURRENCY === tab && (
                  //     <TagComponent className="ml-[12px]">
                  //       {T(item.type === 1 ? "Walk-to-earn" : "Affiliate")}
                  //     </TagComponent>
                  //   )
                  // }
                  onClick={() => onDetail(tab, item.id, item)}
                  key={item.id}
                  coin={item.coin}
                  marketPrice={formatLocalCurrency(
                    item.marketPrice
                  )}
                  amount={formatCurrency(item.amount, 8, getCurrency())}
                  local={formatLocalCurrency(item.local)}
                />
              ))}
            </ContainerTableMobile>
          ) : (
            <RecordNotFound />
          )}
        </MobileContainer>
      </div>
    </div>
  );
};
